$shm_hitalama_map_widget_float_settings $shm_hitalama_map_widget_float
	widget $shm_hitalama_map_widget
		controlled_widget => controlled_widget
	controlled_type_name \
	tools_custom /
		<= Controlled_widget_open $mol_button_minor
			hint \View
			sub /
				<= Controlled_widget_open_icon $mol_icon_image
			click? <=> controlled_title_click? null
	controls /
		<= Settings_head $mol_view
			sub /
				<= Controlled_title $mol_button_minor
					title <= controlled_title \
					click? <=> controlled_title_click? null
				- <= Copy_id $shm_button_copy
					title <= controlled_copy_id \
		<= Settings_scroll $mol_scroll
			sub /
				<= Settings_content $mol_list
					sub /
						^ controlled_settings_content /
	text? \
	Code_label $mol_labeler
		title <= code_label \Действие при клике
		Content <= Code $shm_hitalama_text_editor
			hint <= textarea_hint \
			sidebar_showed true
			value? <=> code? \
			spellcheck false
			owner <= controlled_widget
			images_enabled <= markdown_images_enabled false
